import { Link, useLocation } from 'react-router-dom';
import { Menu, X, Globe } from 'lucide-react';
import { useState } from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { translations } from '../translations';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();
  const { language, toggleLanguage } = useLanguage();
  const t = translations[language];

  const navLinks = [
    { path: '/', label: t.nav.home },
    { path: '/qui-sommes-nous', label: t.nav.about },
    { path: '/programme', label: t.nav.program },
    { path: '/contact', label: t.nav.contact }
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <header className="header-tereka">
      <div className="header-container">
        <Link to="/" className="logo">
          <img 
            src="https://customer-assets.emergentagent.com/job_6282017d-dc9f-4146-a9a5-dd2cb6e49409/artifacts/xdt53dzy_Logo%20%282%29.png" 
            alt="TEREKA Logo" 
            className="logo-image"
          />
        </Link>

        {/* Desktop Navigation */}
        <nav className="desktop-nav">
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              className={`nav-link ${isActive(link.path) ? 'active' : ''}`}
            >
              {link.label}
            </Link>
          ))}
          
          {/* Language Switcher */}
          <button
            onClick={toggleLanguage}
            className="language-switcher"
            aria-label="Change language"
          >
            <Globe size={18} />
            <span>{language === 'fr' ? 'EN' : 'FR'}</span>
          </button>
        </nav>

        {/* Mobile Menu Button */}
        <button
          className="mobile-menu-btn"
          onClick={() => setIsMenuOpen(!isMenuOpen)}
          aria-label="Toggle menu"
        >
          {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {/* Mobile Navigation */}
      {isMenuOpen && (
        <nav className="mobile-nav">
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              className={`mobile-nav-link ${isActive(link.path) ? 'active' : ''}`}
              onClick={() => setIsMenuOpen(false)}
            >
              {link.label}
            </Link>
          ))}
          
          {/* Mobile Language Switcher */}
          <button
            onClick={() => {
              toggleLanguage();
              setIsMenuOpen(false);
            }}
            className="mobile-language-switcher"
          >
            <Globe size={18} />
            <span>{language === 'fr' ? 'English' : 'Français'}</span>
          </button>
        </nav>
      )}
    </header>
  );
};

export default Header;